<template>
  <footer class="l-footer">
    <ul class="l-footer__list">
      <li><a :href="`${endpointWp}/`">トップ</a></li>
      <li class="l-footer__item"><a href="">運営会社</a></li>
      <li class="l-footer__item"><a href="">サイトマップ</a></li>
      <li class="l-footer__item"><a href="">サイトポリシー</a></li>
      <li class="l-footer__item"><a href="">プライバシーポリシー</a></li>
      <li class="l-footer__item"><a href="">お問い合わせ</a></li>
    </ul>
    <p>© 2024 THE POWER NEWS / All rights reserved.</p>
  </footer>
</template>

<script setup lang="ts">
const endpointWp = process.env.VUE_APP_ENDPOINT_WP || '#';
</script>

<style scoped lang="scss">
.l-footer {
  background: #2e2e2e;
  padding: 25px 0 0;
  font-size: 14px;
  color: #fff;
  text-align: center;

  p {
    font-size: 14px;
  }

  &__list {
    display: flex;
    justify-content: center;
    margin-bottom: 50px;
    list-style: none;
    flex-wrap: wrap;

    @media (max-width: 768px) {
      margin-bottom: 24px;
    }
  }

  li {
    position: relative;
    padding: 0 12px;
    font-size: 14px;

    &:not(:last-child) {
      border-right: 1px solid #707070;
    }

    @media (max-width: 768px) {
      width: 50%;
      padding: 15px 0 12px;
      border-bottom: 1px solid #707070;
      border-right: none;

      &:nth-of-type(even) {
        border-left: 1px solid #707070;
      }
    }

    a {
      color: #fff;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
